import React from 'react';
import PropTypes from 'prop-types';
import Slider from "react-slick";
import { NavLink, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import CasinoSearch from '../Casino/CasinoSearch';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Translate } from '../../localization';

const settings = {
    dots: false,
    infinite: false,
    slidesToShow: 7,
    slidesToScroll: 2,
    margin: 30,
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 6,
                slidesToScroll: 1,
            },
        },
        {
            breakpoint: 991,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 1,
            },
        },
        {
            breakpoint: 767,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
            },
        },
        {
            breakpoint: 480,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
            },
        },
    ],
    nextArrow: <KeyboardArrowRightIcon />,
    prevArrow: <KeyboardArrowLeftIcon />,
};

const Categories = () => {

    const { pathname } = useLocation();

    return (
        <div className="casino-categories">
            <div className='casino-categories-nav'>
                <Slider {...settings}>
                    <NavLink
                        to={`/${Translate.getLanguage()}/d/live-casino`}
                        key='lobby'
                        isActive={() => [`${Translate.getLanguage()}/d/casino`].includes(pathname)} >
                        <img className='casino-category-img mr-2' src={`/img/SVG/${'All'}.svg`} alt="" />
                        <p>
                            {Translate.lobby}
                        </p>
                    </NavLink>
                    <NavLink to={`/${Translate.getLanguage()}/d/live-casino/new`} key='Providers'>
                        <img className='casino-category-img mr-2' src={`/img/SVG/${'new'}.svg`} alt="" />
                        <p>
                            {Translate.new}
                        </p>
                    </NavLink>
                    <NavLink to={`/${Translate.getLanguage()}/d/live-casino/categories/Roulette`} key='Providers'>
                        <img className='casino-category-img mr-2' src={`/img/SVG/${'Roulette'}.svg`} alt="" />
                        <p>
                            {Translate.roulette}
                        </p>
                    </NavLink>
                    <NavLink to={`/${Translate.getLanguage()}/d/live-casino/categories/Blackjack`} key='Providers'>
                        <img className='casino-category-img mr-2' src={`/img/SVG/${'Blackjack'}.svg`} alt="" />
                        <p>
                            {Translate.blackjack}
                        </p>
                    </NavLink>
                    <NavLink to={`/${Translate.getLanguage()}/d/live-casino/categories/Baccarat`} key='Providers'>
                        <img className='casino-category-img mr-2' src={`/img/SVG/${'Baccarat'}.svg`} alt="" />
                        <p>
                            {Translate.baccarat}
                        </p>
                    </NavLink>
                    <NavLink to={`/${Translate.getLanguage()}/d/live-casino/categories/Poker`} key='Providers'>
                        <img className='casino-category-img mr-2' src={`/img/SVG/${'Poker'}.svg`} alt="" />
                        <p>
                            {Translate.poker}
                        </p>
                    </NavLink>
                </Slider>
            </div>
            <div className="casino-search-mob">
                <CasinoSearch />
            </div>
        </div >
    );
};

Categories.propTypes = {
    activeCategory: PropTypes.string,
    getCasinoGames: PropTypes.func,
    setCasinoActiveCategory: PropTypes.func,
    setSearchStarted: PropTypes.func,
    casinoCategories: PropTypes.object,
};

export default Categories;
